export enum ErrorCodeEnum {
  INVALID_TOKEN = "INVALID_TOKEN",
  PASSWORD_ALREADY_USED_IN_THE_PAST = "PASSWORD_ALREADY_USED_IN_THE_PAST",
  RESOURCE_ALREADY_EXISTS = "RESOURCE_ALREADY_EXISTS",
  GENERAL_ERROR = "GENERAL_ERROR",
}

export enum ErrorStatusEnum {
  "UNAUTHORIZED" = 401,
  "BAD_REQUEST" = 400,
  "NOT_FOUND" = 404,
}
